import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Tabs as OrigTab, Tab, TabList, TabPanel } from 'react-tabs'

import styles from './styles'

const Tabs = ({
  children = null,
  styleTabs = 'tabs-bordered',
  className = '',
  paddingType = 'default',
  ...rest
}) => {
  return (
    <div
      className={classnames('container-neximo-tabs', className, styleTabs, {
        'padding-default': paddingType === 'default',
      })}
    >
      <OrigTab {...rest}>{children}</OrigTab>
      <style jsx>{styles}</style>
    </div>
  )
}

Tabs.propTypes = {
  children: PropTypes.any,
  onSelect: PropTypes.func,
  selectedIndex: PropTypes.number,
  defaultIndex: PropTypes.number,
  paddingType: PropTypes.oneOf(['default', 'small']),
  styleTabs: PropTypes.oneOf(['tabs-bordered', 'fit-tabs']),
}

export { Tabs, Tab, TabList, TabPanel }
